/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { FetchHandlerModule } from 'nallian-shared-ui/lib/modules';
import communityService from '../services/communityService';

export default ComposedComponent => {
  const service = props => (
    <FetchHandlerModule handleLoading fetches={[props.myCommunityFetch]}>
      {props.myCommunityFetch?.fulfilled && <ComposedComponent {...props} />}
    </FetchHandlerModule>
  );

  service.propTypes = {
    myCommunityFetch: PropTypes.object.isRequired,
  };

  return communityService(service);
};
